
  import { Component, Vue ,Prop} from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import PickerDate from '@/components/picker-date.vue';
  import {
    activityWheelSurfactivityWheelSurf,
    activityDailyCheckactivityDailyCheckPageInit,
    activityTaskRewardactivityTaskRewardPageInit,
    activityInviteFriendlist,
    activityKoiFishlist
  } from "@/api/live"
  
  @Component({  
    name: '',
    components: {
      PageFooter,
      PickerDate
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:{}}) msg!:any
    private keywords = ''
    private classify = 1
    private classifylist:any = [
      // {value:null,label:'全部'},
      {value:1,label:'大转盘抽奖'},
      {value:2,label:'签到活动'},
      {value:3,label:'任务奖励活动'},
      {value:4,label:'邀友有礼'},
      {value:5,label:'锦鲤抽奖'},
    ]
    private classCiting = {
      1:'大转盘抽奖',
      2:'签到活动',
      3:'任务奖励活动',
      4:'邀友有礼',
      5:'锦鲤抽奖',
    }
    private tablelist:any = []
    private tableloading = false
    private pageSize = 20
    private pageNo = 1
    private total = 0
    private choosemsg:any = this.msg

    private mounted () {
      // console.log(this.choosemsg)
      if(this.choosemsg.Id){
        this.classify=this.choosemsg.subdivideType||1
      }
      this.gettablelist()
    }
    private async testMsg(){
      // eslint-disable-next-line no-async-promise-executor
      // return new Promise(async (res,rej)=>{
        try{
          let data = {
            Keywords:'',
            Skip:0,
            Take:9999
          }
          let res:any 
          if(this.classify==1){
            res = await activityWheelSurfactivityWheelSurf(data)
          }else if(this.classify==2){
            res = await activityDailyCheckactivityDailyCheckPageInit(data)
          }else if(this.classify==3){
            res = await activityTaskRewardactivityTaskRewardPageInit(data)
          }else if(this.classify==4){
            res = await activityInviteFriendlist(data)
          }else if(this.classify==5){
            res = await activityKoiFishlist(data)
          }
          if(res.IsSuccess){
            let msg = res.Result.Results.find(v=>v.Id==this.choosemsg.Id)
            if(msg){
              // res(this.choosemsg)
              return {
                ...msg,
                Type:this.classify,
                TypeValue:this.classCiting[this.classify],
                Name:msg.ActivityName||msg.Name
              }
            }else{
              return {}
            }
          }
        }catch(e){
          console.log(e)
        } finally{
          //
        }
      // })
    }
    private async returnchoosemsg(){
      // try{
        // let msg = 
        return await this.testMsg()
      // }finally{
      //   //
      // }
    }
    private checkchange(e,row){
      this.tablelist = this.tablelist.map(v=>{
        v.IsChoose = false
        if(v.Id==row.Id){
          v.IsChoose = true
          this.choosemsg = v
        }
        return v
      })
    }
    private async gettablelist(){
      try{
        this.tableloading = true
        let data = {
          Keywords:this.keywords,
          Skip:(this.pageNo-1)*this.pageSize,
          Take:this.pageSize
        }
        // console.log(this.choosemsg)
        let res:any 
        if(this.classify==1){
          res = await activityWheelSurfactivityWheelSurf(data)
        }else if(this.classify==2){
          res = await activityDailyCheckactivityDailyCheckPageInit(data)
          res.Result.Results = res.Result.Results.map(v=>{
            v.Name = v.ActivityName
            v.StartTime = v.ActivityStartTime
            v.EndTime = v.ActivityEndTime
            return v
          })
        }else if(this.classify==3){
          res = await activityTaskRewardactivityTaskRewardPageInit(data)
          res.Result.Results = res.Result.Results.map(v=>{
            v.Name = v.ActivityName
            v.StartTime = v.ActivityStartTime
            v.EndTime = v.ActivityEndTime
            return v
          })
        }else if(this.classify==4){
          res = await activityInviteFriendlist(data)
          res.Result.Results = res.Result.Results.map(v=>{
            v.Name = v.ActivityName
            return v
          })
        }else if(this.classify==5){
          res = await activityKoiFishlist(data)
          // res.Result.Results = res.Result.Results.map(v=>{
          //   v.Name = v.Name
          //   return v
          // })
        }
        if(res.IsSuccess){
          this.tablelist = res.Result.Results.map(v=>{
            v.Type = this.classify
            v.TypeValue = this.classCiting[this.classify]
            if(v.Id==this.choosemsg.Id){
              v.IsChoose = true
              this.choosemsg = v
            }else{
              v.IsChoose = false
            }
            return v
          })
          this.total = res.Result.Total
        }
      }finally{
        this.tableloading = false
      }
    }
    private changePage(e){
      this.pageNo = e
      this.gettablelist()
    }
    private doSearch(){
      this.pageNo = 1
      this.choosemsg = {}
      this.gettablelist()
    }
  }
